import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { ResourceList } from "@rentiohq/web-shared/dist/components";
import { ChecklistItem, IChecklistItem } from "../ChecklistItem";

interface IProps {
  contract: IContract;
  property: IProperty;
  checklistItems: IChecklistItem[];
}

export const ChecklistItems = ({ contract, checklistItems }: IProps) => {
  return (
    <>
      <ResourceList
        renderItem={(item: IChecklistItem) => (
          <ChecklistItem item={item} contract={contract} />
        )}
        items={checklistItems}
      />
    </>
  );
};
